import { TabPanel as BaseTabPanel } from 'react-tabs';
import styled from 'styled-components';

const TabPanel = styled(BaseTabPanel)``;

// $FlowFixMe
TabPanel.tabsRole = 'TabPanel';

export default TabPanel;
